export default __webpack_public_path__ + "static/media/hero_image.fe5efb72.jpg";